<script>
import { get } from 'lodash'
import { Event, EventStatus, EventTag } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import moment from 'moment'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        widgets: [],
        related_links: [],
        places: []
      },
      tagOptions: [],
      redirectRoute: { name: 'Event List' }
    }
  },
  created() {
    this.fetchTags()
  },
  methods: {
    fetchTags() {
      const params = { page_size: 'max' }
      EventTag.fetch({}, { params }).then(res => {
        this.tagOptions = res.data.results.map(item => ({
          label: item.name,
          value: item.name
        }))
      })
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [
            this.getGeneralTab(),
            this.getPlacesTab(),
            this.getWidgetsTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'title'],
            multilingual: true,
            required: true
          }),
          new fields.WYSIWYG({
            label: 'Opis',
            modelPath: [this, 'form', 'description'],
            multilingual: true,
            required: true
          }),
          new fields.Select({
            label: 'Tagi',
            modelPath: [this, 'form', 'tags'],
            multiple: true,
            filterable: true,
            allowCreate: true,
            options: this.tagOptions
          }),
          new fields.ForeignKey({
            label: 'Status',
            modelPath: [this, 'form', 'status'],
            labelField: 'label',
            valueField: 'value',
            clearable: true,
            paginated: false,
            service: EventStatus
          }),
          new fields.Image({
            label: 'Zdjęcie',
            modelPath: [this, 'form', 'image']
          }),
          new fields.Switch({
            label: 'Ukryte',
            modelPath: [this, 'form', 'is_hidden']
          }),
          new fields.Header({
            type: 'h3',
            text: 'Powiązane linki'
          }),
          new fields.WYSIWYG({
            label: 'Nagłówek linków',
            modelPath: [this, 'form', 'related_links_title'],
            multilingual: true,
            oneLine: true,
            childAttrs: {
              onlyBold: true
            }
          }),
          this.getRelatedLinksFormset()
        ]
      }
    },
    getPlacesTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Miejsca'
        },
        children: [this.getPlacesFormset()]
      }
    },
    getWidgetsTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Widgety'
        },
        children: [new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })]
      }
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          })
        ]
      }
    },
    getRelatedLinksFormset() {
      return new fields.Formset({
        modelPath: [this, 'form', 'related_links'],
        items: this.form.related_links.map(
          (relatedLinkItem, relatedLinkIndex) => {
            return {
              headerLabel: get(relatedLinkItem, ['description_pl']),
              fields: [
                new fields.Input({
                  label: 'Opis',
                  // prettier-ignore
                  modelPath: [this, 'form', 'related_links', relatedLinkIndex, 'description'],
                  multilingual: true,
                  required: true
                }),
                new fields.Link({
                  label: 'Link',
                  // prettier-ignore
                  modelPath: [this, 'form', 'related_links', relatedLinkIndex, 'link'],
                  required: true
                })
              ]
            }
          }
        )
      })
    },
    getPlacesFormset() {
      return new fields.Formset({
        modelPath: [this, 'form', 'places'],
        blankObject: { dates: [], prices: [] },
        items: this.form.places.map((itemPlace, indexPlace) => {
          return {
            headerLabel: itemPlace.title_pl,
            fields: [
              new fields.Input({
                label: 'Nazwa',
                modelPath: [this, 'form', 'places', indexPlace, 'title'],
                multilingual: true,
                required: true
              }),

              new fields.Input({
                label: 'Miejsce',
                modelPath: [this, 'form', 'places', indexPlace, 'place_name'],
                multilingual: true,
                required: true
              }),
              new fields.Input({
                label: 'Kup bilet URL',
                // prettier-ignore
                modelPath: [this, 'form', 'places', indexPlace, 'buy_ticket_url']
              }),
              new fields.WYSIWYG({
                label: 'Informacja z gwiazdką',
                // prettier-ignore
                modelPath: [this, 'form', 'places', indexPlace, 'asterisk_info'],
                multilingual: true,
                oneLine: true,
                childAttrs: {
                  onlyBold: true
                }
              }),
              new fields.Image({
                label: 'Zdjęcie',
                modelPath: [this, 'form', 'places', indexPlace, 'image']
              }),
              new fields.Header({
                type: 'h3',
                text: 'Daty i godziny'
              }),
              this.getDatesFormset(itemPlace, indexPlace)
            ]
          }
        })
      })
    },
    getDatesFormset(itemPlace, indexPlace) {
      return new fields.Formset({
        modelPath: [this, 'form', 'places', indexPlace, 'dates'],
        blankObject: { prices: [] },
        items: itemPlace.dates.map((itemDate, indexDate) => {
          return {
            headerLabel: moment(itemDate.date).format('YYYY-MM-DD HH:mm:ss'),
            fields: [
              new fields.Date({
                label: 'Data i godzina',
                // prettier-ignore
                modelPath: [this, 'form', 'places', indexPlace, 'dates', indexDate, 'date'],
                type: 'datetime',
                required: true
              }),
              new fields.Header({
                type: 'h4',
                text: 'Ceny biletów'
              }),
              this.getDatePricesFormset(itemDate, indexPlace, indexDate)
            ]
          }
        })
      })
    },
    getDatePricesFormset(itemDate, indexPlace, indexDate) {
      return new fields.Formset({
        // prettier-ignore
        modelPath: [this, 'form', 'places', indexPlace, 'dates', indexDate, 'prices'],
        items: itemDate.prices.map((itemPrice, indexPrice) => {
          return {
            headerLabel: get(itemPrice, [`name_${this.currentLanguage}`]),
            fields: [
              new fields.Input({
                label: 'Nazwa',
                // prettier-ignore
                modelPath: [this, 'form', 'places', indexPlace, 'dates', indexDate, 'prices', indexPrice, 'name'],
                multilingual: true,
                required: true
              }),
              new fields.Input({
                label: 'Cena',
                // prettier-ignore
                modelPath: [this, 'form', 'places', indexPlace, 'dates', indexDate, 'prices', indexPrice, 'first_price'],
                multilingual: true,
                required: true
              })
            ]
          }
        })
      })
    }
  },
  computed: {
    service() {
      return Event
    },
    currentLanguage() {
      return this.$store.state.selectedLanguage
    }
  }
}
</script>
